// src/services/languageService.js
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';
import i18n from '../i18n'; 

export const LoadLanguage = (languageStr) => { 
  return new Promise((resolve, reject) => {
    if (!languageStr) return resolve('english'); // Default fallback

    if (i18n.hasResourceBundle(languageStr, 'translation')) {
      return resolve(languageStr);
    }

    HttpServices.LanguagePost({
      url: userModuleURL.getLanguageJson,
      body: { language: languageStr },
      successCallback: (data) => {
        i18n.addResourceBundle(languageStr, 'translation', data, true, true);
        resolve(languageStr);
      },
      failureCallback: (err) => {
        console.error(`Failed to load: ${languageStr}`, err);
        resolve('english'); 
      }
    });
  });
};